export const REMEMBRANCE_INVITATION_DEFAULT_PATTERN = `
<div style="font-family: Arial, sans-serif; font-size: 11pt; line-height: 1.25;">
<table style="border: 0; width: 100%;">
    <tbody>
        <tr>
            <td style="border: 0; width: 30%; text-align: left; vertical-align: top;">{{sluzba_logo}}</td>
            <td style="border: 0; width: 70%; text-align: right; vertical-align: top; font-size: 9pt;">
                <p style="margin: 0; line-height: 11pt;">{{organizace_nazev}}</p>
                <p style="margin: 0; line-height: 11pt;">{{sluzba_nazev}}</p>
                <p style="margin: 0; line-height: 11pt;">{{sluzba_adresa}}</p>
                <p style="margin: 0; line-height: 11pt;">tel.: {{sluzba_telefon}}</p>
                <p style="margin: 0; line-height: 11pt;">IČ: {{sluzba_ico}}</p>
            </td>
        </tr>
    </tbody>
</table>
<p style="text-align: center; margin-top: 32px;">Zveme Vás i Vaše příbuzné, přátele a známé na</p>
<h1 style="text-align: center; margin: 32px 0;">{{vzpominkoveSetkani_nazev}}</h1>
<p style="text-align: center; margin-bottom: 32px;"><strong>
    {{vzpominkoveSetkani_denTydne}} {{vzpominkoveSetkani_datum}} ve
    {{vzpominkoveSetkani_cas}} hod. {{vzpominkoveSetkani_misto}}
</strong></p>
<p>Tato akce je věnována vzpomínce na zemřelé klienty, které doprovázeli pracovníci naší organizace
    a kteří měli možnost společně s Vámi o ně pečovat v domácím prostředí.</p>
<p>Během akce Vám bude představena Vzpomínková kniha, kde je zapsáno jméno Vašeho zemřelého.
    Pro vzpomínku si budete moci také na akci zapálit svíčku.</p>
<p style="margin-top: 20px;">Zveme Vás také na společné setkání s malým pohoštěním. Budete mít možnost
    popovídat si s pracovníky, které jste přijali do své rodiny při pečování o Vašeho blízkého.</p>
<p style="margin-top: 20px;">Bude nám ctí, pokud se společného setkání zúčastníte. Jste srdečně zváni
    i s Vašimi blízkými.</p>
<p style="margin-top: 20px;">Prosíme Vás o informaci, zda se zúčastníte/nezúčastníte společného setkání
    (případně kolik vás přijede). Počet potřebujeme znát z důvodu zajištění odpovídajícího prostoru
    k setkání i drobného pohoštění. Informaci prosím zatelefonujte nebo napište emailem na níže uvedený
    kontakt nejpozději do {{vzpominkoveSetkani_potvrditDo}}. Děkujeme.</p>
<p style="margin-top: 28px;">Pokud nemáte zájem o další kontakt s námi, nebo si nepřejete, aby jméno
    Vašeho zesnulého bylo zapsáno ve Vzpomínkové knize, dejte nám také prosím vědět na níže uvedeném
    kontaktu.</p>
<p style="margin-top: 20px;">Za tým naší služby</p>
</div>
`;
